__turbopack_context__.v({
  "body": "MzIQHW_body",
  "schemaTable": "MzIQHW_schemaTable",
  "wrapper": "MzIQHW_wrapper",
});
